import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GIS_SEARCH } from '@rsos/capstone/src/constants/capabilities';
import { CAPSTONE } from '@rsos/constants/appNames';
import { PREMIUM_GIS_SEARCH } from '@rsos/constants/permissions';
import { selectUserPermissionsByApp, selectUser } from '@rsos/sinatra';
import useAccess from '@rsos/utils/useAccess';
import usePortalType from '@rsos/utils/usePortalType';
import usePrevious from '@rsos/utils/usePrevious';
import { selectProductToken } from '../../../utils/getProductToken';
import hasMedicAlertAccess from '../../../utils/hasMedicAlertAccess';
import ConnectedUniversalSearch from './ConnectedUniversalSearch';
import { search, selectSearchTerm, selectSearchType } from './searchSlice';

const ConnectedUniversalSearchContainer = ({
  filteredCalls,
  hasManageAccess,
  setShowW3wCallPane,
  mafError,
  setMafError,
  adrError,
  setADRError,
  setActiveQueueTab,
  isInternational,
}) => {
  const dispatch = useDispatch();

  const searchTerm = useSelector(selectSearchTerm);
  const prevSearchTerm = usePrevious(searchTerm);
  const { productToken } = useSelector(selectProductToken);
  const { currentRole } = useSelector(selectUser);
  const userRoleName = currentRole.name || '';
  const searchType = useSelector(selectSearchType);
  const { isPremiumUser } = usePortalType();
  const permissions = useSelector(state =>
    selectUserPermissionsByApp(state.sinatra.user, CAPSTONE),
  );
  const hasGisSearchAccess =
    !!useAccess(GIS_SEARCH, PREMIUM_GIS_SEARCH) && isPremiumUser;

  const hasMAaccess = hasMedicAlertAccess(permissions);
  const what3words = useSelector(state => state.what3words);
  const { numberWithNewLocation, selectedCallerID, locationError } =
    useSelector(state => state.emergencyCalls);

  const setSearchTerm = useCallback(
    searchTerm => {
      dispatch(search({ searchTerm }));
    },
    [dispatch],
  );
  const setSearchType = useCallback(
    searchType => {
      dispatch(search({ searchType }));
    },
    [dispatch],
  );

  return (
    <ConnectedUniversalSearch
      filteredCalls={filteredCalls}
      isInternational={isInternational}
      hasManageAccess={hasManageAccess}
      productToken={productToken}
      setShowW3wCallPane={setShowW3wCallPane}
      mafError={mafError}
      setMafError={setMafError}
      adrError={adrError}
      setADRError={setADRError}
      searchTerm={searchTerm}
      prevSearchTerm={prevSearchTerm}
      searchType={searchType}
      setSearchTerm={setSearchTerm}
      setSearchType={setSearchType}
      userRoleName={userRoleName}
      isPremiumUser={isPremiumUser}
      hasMAaccess={hasMAaccess}
      what3words={what3words}
      numberWithNewLocation={numberWithNewLocation}
      selectedCallerID={selectedCallerID}
      locationError={locationError}
      hasGisSearchAccess={hasGisSearchAccess}
      setActiveQueueTab={setActiveQueueTab}
    />
  );
};
export default ConnectedUniversalSearchContainer;
